import { render, staticRenderFns } from "./ClassBox.vue?vue&type=template&id=b93fa9ac&"
import script from "./ClassBox.vue?vue&type=script&lang=js&"
export * from "./ClassBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports